import { ContextStore } from 'bernie-plugin-mobx';
import { inject } from 'mobx-react';
import * as React from 'react';

import { PropertySingleOffer } from '@shared-ui/lodging-property-offers';
import { RefTarget } from '@shared-ui/ref-context';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';

import { isPetsAmenityFilterPresent } from 'src/common/utils/pets-utils';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';
import { SingleOfferSearchForm } from 'components/infosite/single-offer-search';

interface PropertySingleOfferWrapperProps extends SharedUiWrapperProps {
  currentHotel?: CurrentHotelStore;
  context?: ContextStore;
}

export const PropertySingleOfferWrapper: React.FC<PropertySingleOfferWrapperProps> = inject(
  'context',
  'currentHotel'
)(({ context, currentHotel, inputs }) => {
  currentHotel &&
    React.useEffect(() => {
      currentHotel.showPetsOnSingleOffer = isPetsAmenityFilterPresent(context, currentHotel);
    }, []);

  return (
    <div>
      <RefTarget name="Offers" tabIndex={0}>
        <PropertySingleOffer inputs={inputs} skipSsr={true}>
          <SingleOfferSearchForm />
        </PropertySingleOffer>
      </RefTarget>
    </div>
  );
});

PropertySingleOfferWrapper.displayName = 'PropertySingleOfferWrapper';

export const SharedUiPropertySingleOfferWrapper = withSharedUiPropertyOffers(PropertySingleOfferWrapper);
